import { Component, CUSTOM_ELEMENTS_SCHEMA, input, ChangeDetectionStrategy} from '@angular/core';

/**
 * Rodapé da aplicação.
 *
 * NOTA: implementação ainda é um placeholder — o template exibe um texto fixo
 * e os inputs abaixo ({@link text}, {@link logo}, {@link fluid}) ainda não estão
 * conectados ao template. Mantidos para compatibilidade de API.
 */
@Component({
    selector: 'conversai-footer',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Footer {
    /** Texto a ser exibido no rodapé (ainda não conectado ao template). */
    text = input<string>('');

    /** URL do logo (ainda não conectado ao template). */
    logo = input<string>('');

    /** Indica se o rodapé ocupa toda a largura (ainda não conectado). */
    fluid = input<boolean>(true);
}
